module.exports = __webpack_public_path__ + "static/media/clothes_02.582bbbab.png";